import jsPDF from "jspdf";
import { createApp } from "vue";
import { renderToString } from "@vue/server-renderer";
import TestTempComponent from "@/components/Municipal/Infractions/TemplatesPdf/TestTempComponent.vue";
import ElegantTemplate from "@/components/Municipal/Infractions/TemplatesPdf/ElegantTemplate.vue";
import ControledTemp from "@/components/Municipal/Infractions/TemplatesPdf/ControledTemp.vue";

class PDFDocument {
  static async DownloadTest() {
    try {
      const dynamicData = {
        title: "Constancia personalizada",
        description: "Este es un ejemplo con datos dinámicos.",
        additionalData: ["hola 1", "hola 2", "hola 3"],
        links: [
          "https://d24g0foqntlzx0.cloudfront.net/files/1740423771135_9ca6c29c-c7a4-47f1-8295-ba0f26ba68c6",
          "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
        ],
      };
      const app = createApp(ElegantTemplate, dynamicData);
      const htmlString = await renderToString(app);
      const doc = new jsPDF("p", "pt", "A4");

      // Crear el PDF
      const documentBlob = await new Promise((resolve, reject) => {
        doc.html(htmlString, {
          x: 0,
          y: 0,
          width: 550,
          windowWidth: 595,
          html2canvas: { scale: 1 },
          callback: (doc) => {
            doc.save("Constancia.pdf");
            const document = doc.output("blob");
            resolve(document); // Devolver el Blob
          },
          error: (err) => reject(err),
        });
      });

      // Devolver el archivo como un Blob
      return new File([documentBlob], "GeneratedDocument.pdf", {
        type: "application/pdf",
      });
    } catch (error) {
      console.error("Error saving file:", error);
    }
  }

  static async DownloadInfoTest(data) {
    try {
      const dynamicData = {
        infraction: data,
      };
      const app = createApp(ControledTemp, dynamicData);
      const htmlString = await renderToString(app);
      const doc = new jsPDF("p", "pt", "A4");

      // Crear el PDF
      const documentBlob = await new Promise((resolve, reject) => {
        doc.html(htmlString, {
          x: 0,
          y: 0,
          width: 550,
          windowWidth: 595,
          html2canvas: { scale: 1 },
          callback: (doc) => {
            //doc.save("Constancia.pdf"); // para guardar el documento
            const document = doc.output("blob");
            resolve(document); // Devolver el Blob
            //lineas para abrir el archivo en otra pestaña
            let pdfUrl = URL.createObjectURL(document);
            window.open(pdfUrl, "_blank");
          },
          error: (err) => reject(err),
        });
      });

      // Devolver el archivo como un Blob
      return new File([documentBlob], "GeneratedDocument.pdf", {
        type: "application/pdf",
      });
    } catch (error) {
      console.error("Error saving file:", error);
    }
  }

  static async DownloadInfoTest2(data) {
    try {
      const dynamicData = {
        infraction: data,
      };
      const app = createApp(ControledTemp, dynamicData);
      const htmlString = await renderToString(app);
      const doc = new jsPDF("p", "pt", "A4");

      // Parsear el HTML generado
      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(htmlString, "text/html");
      const pages = htmlDoc.querySelectorAll(".page");
      // Generar una página por cada .page
      for (let i = 0; i < pages.length; i++) {
        const pageHtml = pages[i];

        // Agregar la página al PDF
        await new Promise((resolve, reject) => {
          doc.html(pageHtml, {
            x: 0,
            y: 0,
            width: 550,
            windowWidth: 595,
            html2canvas: { scale: 1 },
            callback: () => {
              resolve();
            },
            error: (err) => reject(err),
          });
        });

        // Agregar nueva página si no es la última
        if (i < pages.length - 1) {
          doc.addPage();
        }
      }

      // Obtener el Blob y abrir en nueva pestaña
      const documentBlob = doc.output("blob");
      const pdfUrl = URL.createObjectURL(documentBlob);
      window.open(pdfUrl, "_blank");

      return new File([documentBlob], "GeneratedDocument.pdf", {
        type: "application/pdf",
      });
    } catch (error) {
      console.error("Error saving file:", error);
    }
  }

  static async NotificationPDF() {
    try {
      const dynamicData = {
        title: "Constancia de notificacion",
        description: "Este es un ejemplo con datos dinámicos de notificacion.",
      };
      const app = createApp(TestTempComponent, dynamicData);
      const htmlString = await renderToString(app);
      const doc = new jsPDF("p", "pt", "A4");

      // Crear el PDF
      const documentBlob = await new Promise((resolve, reject) => {
        doc.html(htmlString, {
          x: 0,
          y: 0,
          width: 555,
          html2canvas: { scale: 0.75 },
          callback: (doc) => {
            doc.save("Constancia.pdf");
            const document = doc.output("blob");
            resolve(document); // Devolver el Blob
          },
          error: (err) => reject(err),
        });
      });

      // Devolver el archivo como un Blob
      return new File([documentBlob], "GeneratedDocument.pdf", {
        type: "application/pdf",
      });
    } catch (error) {
      console.error("Error saving file:", error);
    }
  }
}

export default PDFDocument;
